module.exports = __webpack_public_path__ + "img/background-pattern-decorative.8115961f.svg";